import { makeStyles } from '@mui/styles';

import Header from './Header';
import Footer from './Footer';

export default function Layout({ children }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Header />
      <div className={classes.content}>{children}</div>
      <Footer />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: 'auto',
  },
}));
